import React from 'react'
import { Button, Modal } from 'react-angle-dashboard-components'
import { ReactComponent as ExclaimationImg } from '../../../../assets/exclaimationCircle.svg'

interface ISkipModalProps {
  open: boolean

  onClose: () => void
  onSkip: () => void
}

export const SkipModal = ({
  open,

  onClose,
  onSkip
}: ISkipModalProps) => {
  return (
    <>
      <Modal
        style={{
          zIndex: 9000
        }}
        centered
        show={open}
      >
        <Modal.Header className="border-bottom pb-2" closeButton>
          <h5>Skip Adding Previous Plans</h5>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column align-items-center">
          <ExclaimationImg
            fill="#EDCA60"
            style={{
              width: 36,
              height: 36,
              overflow: 'visible',
              marginBottom: 20
            }}
          />
          <p className="text-center">
            Skipping the process of adding previous plans may result in less
            accurate rates. Would like to proceed without providing this
            information?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="py-2" variant="outline-primary" onClick={onClose}>
            Close
          </Button>
          <Button className="py-2" onClick={onSkip}>
            Skip
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SkipModal
